import React, { useState } from "react";
import Config from "../config.json";
import parse from 'html-react-parser';
import { useNavigate, Link } from "react-router";

function Directory() {
  
  const folders = Config.storage.folders
    .filter((f) => f.hidden !== true)
    .sort((a, b) => a.name.localeCompare(b.name));

  const navigate = useNavigate();

  const [filterText, setFilterText] = useState("");

  function handleCardClick(routePath) {
    navigate(routePath);
  }

  return (
    <main id="main-content" className="main mt-3">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h1>Document Center</h1>
            <p>
              Requests for public records not located on this site can be submitted
              through our{" "}
              <a href="https://bellevuewa.govqa.us/WEBAPP/_rs/(S(xkanclqt0ptzvf2zwugaifv5))/SupportHome.aspx" aria-label="Link to the Public Records portal">
                Public Records portal
              </a>
              . Requests for police public records and building and land use permit
              records can also be submitted online through this portal. Please note
              that you will be required to create an account for the Public Records
              Portal and provide at least one contact method.
            </p>
            
            <div className="input-group mb-3">
              <input type="text" value={filterText} onChange={(e) => setFilterText(e.target.value)} className="form-control" placeholder="Filter collections" aria-label="Filter collections" aria-describedby="button-addon2" />
            </div>
          </div>
         </div>
        <div className="row">
          {folders.filter((folder) => folder.title.toLowerCase().includes(filterText.toLowerCase())).map((folder) => (
            <div key={folder.name} className="col-xs-12 col-sm-6 col-md-4 mb-4">
                <div className="card h-100" >
                  <div className="card-body d-flex flex-column">
                    <h2 className="card-title h5"><Link className="h5" to={folder.routePath}>{folder.title}</Link></h2>
                    <p className="card-text">{parse(folder.description)}</p>
                  </div>
                  <div className="card-footer">
                    <p><Link className="card-link" to={folder.routePath}>{folder.title}</Link></p>
                  </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}

export default Directory;